import {
  Response,
  DynamicQuestionAnswerItem,
  DynamicQuestionAnswerRecord,
  DynamicQuestionAnswerRecordResponse,
} from "src/types";
import { baseApi } from "./baseApi";

const dynamicQuestionApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    postDynamicQuestion: build.mutation<Response, { solicitudId: string; body: DynamicQuestionAnswerItem[] }>({
      query: ({ solicitudId, body }) => ({
        url: `solicitudes/${solicitudId}/dynamic_question`,
        method: "POST",
        body,
      }),
    }),
    getDynamicQuestionByApplication: build.query<DynamicQuestionAnswerRecord[], string>({
      query: (solicitudId) => `solicitudes/${solicitudId}/dynamic_question`,
      transformResponse: (response: DynamicQuestionAnswerRecordResponse) => {
        return response.data.data;
      },
    }),
  }),
});

export const { usePostDynamicQuestionMutation, useLazyGetDynamicQuestionByApplicationQuery } = dynamicQuestionApi;
